import axios  from 'axios';

import React, {useState,setState} from 'react';
import baseUrl from '../../../services/api';
import './style.css'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
const FormComponent = () => {
const [firstName, setFirstName] = useState(null);
const [lastName, setLastName] = useState(null);
const [email, setEmail] = useState(null);
const [password,setPassword] = useState(null);
const [confirmPassword,setConfirmPassword] = useState(null);
const [admin,setAdmin] = useState(false);
const [user,setUser] = useState(false);
const [passError,setPassError]=useState(false)
const [errorm, setErrorm] = useState("")

const handleInputChange = (e) => {

    const {id , value} = e.target;
    if(id === "firstName"){
        setFirstName(value);
    }
    if(id === "lastName"){
        setLastName(value);
    }
    if(id === "email"){
        setEmail(value);
    }
    if(id === "password"){
        setPassword(value);
    }
    if(id === "confirmPassword"){
        setConfirmPassword(value);
    }


}
const handleCheckboxUser=(e)=>{
    const {id , value} = e.target;
    if(id === "user"){
    
      setUser(!user)
    }
}
const handleCheckboxAdmin=(e)=>{
    const {id , value} = e.target;
    if(id === "admin"){
        
        setAdmin(!admin);
    }
}

const handleSubmit  = (e) => {
   if(firstName === ""){
    setErrorm("First name must be field ");
   }
   else if(lastName === ""){
    setErrorm("Last name must be field ");
   }
   else if(email === ""){
    setErrorm("Email must be field ");
   }
   else if(password === ""){
    setErrorm("Password must be field ");
   }
   else if(confirmPassword === ""){
    setErrorm("Confirm Password must be field ");
   }
   else if(password.length < 6){
    setErrorm("Password length must be greater than 6  ");
   }
   else if(password!==confirmPassword){
    setErrorm("Password Not Match ");
    }else{
      setPassError(false)
      const data={
        "firstname":firstName,
        "lastname":lastName,
        "email":email,
        "password":password,
        "roleadmin":admin,
        "roleuser":user
        
      }
        // alert('A form was submitted: ' );
        try{
          axios
          .post(`${baseUrl}/createUser`, data)
          
          .then((response) => 
          {console.log("kkkkkhhhh");
          alert(JSON.stringify(response.data))
            console.log(response)
            sessionStorage.setItem('mess', response.data.message);
        }
            
          )     
          .catch(err => {
            console.error(err);
            
          }); 
          e.preventDefaulte();
        } catch (error) {
          if(error.message === 'Network Error'){
              alert('no internet connection');
          }
      }
             
    }
    
}
  return (

    <>
    <Form>
    
         <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>First Name</Form.Label>
              
              <Form.Control type="text" value={firstName} onChange={(e) => handleInputChange(e)} id="firstName" placeholder="Enter First Name" />
             
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Last Name</Form.Label>
              <Form.Control id="lastName" value={lastName}  onChange={(e) => handleInputChange(e)} type="text" placeholder="Enter Last Name" />
             
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" id="email"  value={email} onChange={(e) => handleInputChange(e)} placeholder="Enter email" />
              <Form.Text className="text-muted">
                  We'll never share your email with anyone else.
              </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" id="password" value={password} onChange={(e) => handleInputChange(e)} placeholder="Password" />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control type="password" id="confirmPassword" value={confirmPassword} onChange={(e) => handleInputChange(e)} placeholder="Confirm Password" />
          </Form.Group>
         
          <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check type="checkbox" id="admin" name="admin" onChange={(eee) => handleCheckboxAdmin(eee)} label="Admin" />
              <Form.Check type="checkbox" id="user" name="user" onChange={(e) => handleCheckboxUser(e)} label="User" />
          
          </Form.Group>
          {errorm?<span>{errorm}</span>:<div></div>}
          <br></br>
          <Button variant="primary" onClick={() => handleSubmit()} >
          Register User
          </Button>
      </Form>
    
 </>
  )
}
export default FormComponent